export const commonColors = {
    mangoTango: '#D47200',
    cyanBlue: '#13B5EA',
    darkCyanBlue: '#2F4858',
    darkCyanTeal: '#039590',
    marinerBlue: '#4C5E9B',
    chineseSilver: '#C9C9C9',
    darkPumpkin: '#B56a12',
    graniteGrey: '#5E5F61',
    white: '#ffffff',
    sustainabilityGreen: '#7FC162',
    darkGrey: '#343434',
    black: '#000000',
    governorBayBlue: '#44509C',
    harleyDavidsonOrangeRed: '#C72601',
    mantisLightGreen: '#7FC162',
    lightSkyBlue: '#13B5EA',
    rhinoShaleBlue: '#394659',
    tunaGrey: '#495057',
    celloBlue: '#385464',
    balticSeaDarkShaleBlue: '#343A3F',
    pacificBlue: '#0098D6',
    slateGrey: 'slategrey',
    lightPrussianBlue: '#04325B',
    grey: 'grey',
    red: 'red',
    entityTagThemeBlue: '#0098D6',
    entityTagPaleBlue: 'rgba(0, 152, 214, 0.05)',
    button: {
        hoverBG: 'rgba(255,255,255,1.0)',
        BG: 'rgba(0,0,0,0.15)',
        border: 'rgba(255,255,255,0.5)',
        hoverLabel: 'rgb(9,27,50)',
        activeLabel: 'rgba(255,255,255,1.0)',
        disabledLabel: 'rgba(255,255,255,0.25)',
        disabledButton: 'rgba(0, 0, 0, 0.26)',
    } as const,
} as const

export const fieldValidations = {
    workItem: {
        description_maxLength: 5000,
        updateSummary_maxLength: 5000,
    },
    //these are also used for predefinedTask
    workItemTask: {
        name_maxLength: 510,
        description_maxLength: 5000,
    } as const,
} as const

export const regexes = {
    guidRegex: /([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})/gi,
}
